// التطبيق على التلفزيون: الإطار نفسه بتخطيط عرضيّ، والريموت بدل اللمس.

/** الأقسام على التلفزيون: لا مجلس ولا استديو ولا فتاوى — ميكروفون وكتابة. */
export const TV_TABS = ['home', 'radios', 'prayer', 'lessons', 'favorites'];

/** هل الجهاز تلفزيون؟ يسأل أندرويد (UiModeManager)؛ المتصفح ليس تلفزيوناً. */
export async function detectTv() {
  if (typeof window === 'undefined' || !window.Capacitor?.isNativePlatform?.()) return false;
  try {
    const res = await window.Capacitor.Plugins?.AppSettings?.isTv?.();
    return Boolean(res?.tv);
  } catch {
    return false;
  }
}

/**
 * زر الرجوع.
 *
 * الأقسام تبويباتٌ في صفحة واحدة لا صفحات، فكان الرجوع يُخرج من التطبيق
 * من أي قسم. صار يغلق النافذة، ثم يرجع للرئيسية، ثم يخرج.
 */
export function backAction({ modalOpen, tab }) {
  if (modalOpen) return 'close-modal';
  if (tab !== 'home') return 'go-home';
  return 'exit';
}

/**
 * طبقة داخل نافذة (كورقة التفسير في المصحف) تأخذ الرجوع لنفسها قبل أن
 * تُغلق النافذة كلها: تستمع لهذا الحدث وتستدعي preventDefault.
 */
export const BACK_EVENT = 'moslam:back';

/** يسأل الطبقات الداخلية أولاً؛ true إن أخذت إحداها الرجوع. */
export const backClaimedByLayer = () =>
  !window.dispatchEvent(new Event(BACK_EVENT, { cancelable: true }));
